import React from 'react';

import QuotaVenta  from 'components/Tvendo/Sale/QuotaBPartner/Unilever/QuotaVenta/List';

export default function () {
  return <QuotaVenta  />;
}